export const createSportsnewSubmissionGate = () => {
  let inFlightOwner = null;

  const ownerKey = (owner) => {
    if (!owner) return '__default__';
    return `${String(owner.userId ?? '')}:${String(owner.generation ?? '')}`;
  };

  return Object.freeze({
    tryAcquire(owner = null) {
      const nextOwner = ownerKey(owner);
      if (inFlightOwner === nextOwner) return false;
      inFlightOwner = nextOwner;
      return true;
    },
    release(owner = null) {
      if (inFlightOwner !== ownerKey(owner)) return false;
      inFlightOwner = null;
      return true;
    },
    isLocked(owner = null) {
      return inFlightOwner === ownerKey(owner);
    },
  });
};
